// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"LinkDialog_tooltipContainer__0gVtY","tooltipOverlay":"LinkDialog_tooltipOverlay__Fv5xN"};